import { Directive, Input, HostListener } from '@angular/core';
import { ReportingService } from './reporting.service';

@Directive({
  selector: '[TrackClick]'
})
export class TrackClickDirective {
  constructor(
    private reportingService: ReportingService,
  ) {}

  // Comma separated list of events, or string of custom link tracking
  @Input('TrackClick') event: string;

  // Whether or not it is custom link tracking
  @Input('custom') custom: boolean;

  @HostListener('click', ['$event.target']) onClick(element: any) {
    if (!this.event) return true;
    this.reportingService.trackCustomEvent(this.event, element);
  }
}
